<template>
  <v-row justify="center">
    <v-dialog
        persistent
        v-model="isApplicationDialogOpen"
        hide-overlay
        content-class="custom-dialog"
        transition="dialog-bottom-transition"
    >
      <v-card>
        <ValidationObserver v-slot="{ invalid, errors }" ref="validform">
          <form @submit.prevent="submit()" class="t-c">
            <div class="d-flex toolbar">
              <v-toolbar-title>오늘의 식당 신청하기</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn color="darken-1" text @click="closeDialog">
                  <img src="../../assets/images/todaystore/btn-close.svg"/>
              </v-btn>
              </v-toolbar-items>
            </div>
            <v-row class="mb-4 head-title" no-gutters>
              <v-col cols="12" class="t-l">
                <h3>
                  오늘의 식당 신청 시,<br/>
                  비상금 한도 <span>10% 즉시 상향!</span></h3>
              </v-col>
            </v-row>
            <v-row class="mb-4 phone" no-gutters>
              <v-col cols="3" class="t-l">
                <span class="field-title">연락처</span>
              </v-col>
              <v-col cols="9">
                <FormInput
                  type="tel"
                  name="phone"
                  v-model="phone"
                  @input="inputPhoneNum()"
                  rules="required|numeric|phone"
                  placeholder="휴대폰번호를 입력해주세요."
                />
              </v-col>
              <v-col cols="3">
              </v-col>
              <v-col cols="9">
                <p
                  v-if="errors.phone != null && errors.phone[0] != null"
                  class="error-text t-l"
                >{{ errors.phone[0] }}</p>
              </v-col>
            </v-row>
            <v-row class="number_of_table" no-gutters>
              <v-col cols="3" class="t-l">
                <span class="field-title">테이블<br/>개수</span>
              </v-col>
              <v-col cols="9">
                <FormInput
                  type="number"
                  name="number_of_table"
                  v-model="number_of_table"
                  rules="required|numeric"
                  ref="number_of_table"
                  placeholder="테이블 개수를 입력해주세요."
                />
              </v-col>
              <v-col cols="3">
              </v-col>
              <v-col cols="9">
                <p
                  v-if="errors.number_of_table != null && errors.number_of_table[0] != null"
                  class="error-text t-l"
                >{{ errors.number_of_table[0] }}</p>
              </v-col>
              <v-col cols="12">
                <p class="description t-c">월 29,000원 (1개월 무료)</p>
              </v-col>
            </v-row>
            <v-btn
              v-ripple
              type="submit"
              :disabled="invalid"
              :class="{'active':!invalid}"
              class="confirm-btn"
            >
              신청 완료하기
            </v-btn>
          </form>
        </ValidationObserver>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import FormInput from '@/components/form/FormInput'
import subscriptionApi from '@/api/todaystore/subscriptionApi'

export default {
  name: 'ApplicationDialog',
  components: {
    FormInput
  },
  props: ['isApplicationDialogOpen', 'userData'],
  data() {
    return {
      phone: '',
      connect_service: '',
      number_of_table: null,
      utm_source: '',
      utm_medium: '',
      utm_campaign: '',
    }
  },
  mounted() {
    this.focusInput()
  },
  created() {
    if (this._.get(this.userData, 'user.phone')) { this.phone = this._.get(this.userData, 'user.phone') }
    if (this._.get(this.userData, 'user.number_of_table')) { this.number_of_table = this._.get(this.userData, 'user.number_of_table') }
    if (this._.get(this.userData, 'user.connect_service')) { this.connect_service = this._.get(this.userData, 'user.connect_service') }
    if (this._.get(this.userData, 'user.utm_source')) { this.utm_source = this._.get(this.userData, 'user.utm_source') }
    if (this._.get(this.userData, 'user.utm_medium')) { this.utm_medium = this._.get(this.userData, 'user.utm_medium') }
    if (this._.get(this.userData, 'user.utm_campaign')) { this.utm_campaign = this._.get(this.userData, 'user.utm_campaign') }
  },
  methods: {
    focusInput() {
      this.$refs.number_of_table.$el.focus()
    },
    inputPhoneNum() {
      let phone = this.phone
      if (phone != null && phone.length > 0) {
        this.phone = phone.replace(/[^\d]/g, '')
      }
    },
    closeDialog() {
      this.$emit('close-application-dialog', false)
    },
    async submit() {
      try {
        const formData = new FormData()
        formData.append('phone', this.phone)
        formData.append('number_of_table', this.number_of_table)
        formData.append('connect_service', this.connect_service)
        formData.append('utm_source', this.utm_source)
        formData.append('utm_medium', this.utm_medium)
        formData.append('utm_campaign', this.utm_campaign)
        await subscriptionApi.postSubscription(formData)
        alert('신청 완료되었습니다!')
      } catch (e) {
        alert('문제가 발생했습니다. 문제가 지속될 시 고객센터로 문의주세요.')
      }
      this.closeDialog()
    },
  }
}
</script>
<style lang="scss" scoped>
  .v-toolbar {
    &__title {
      font-size: 1.188rem;
      font-weight: 600;
    }
  }
  .v-btn:not(.v-btn--round).v-size--default {
    height: 20px;
    min-width: 20px;
    padding: 0;
  }
  form {
    padding-top: 3.2vh !important;
    .row {
      display: flex;
      align-items: center;
    }
    .row, .toolbar {
      padding-left: 6vw !important;
      padding-right: 6vw !important;
    }
    .toolbar {
      margin-bottom: 1.9rem;
    }
    .head-title {
      h3 {
        font-size: 16px;
        font-weight: 600;
        line-height: 1.38;
        letter-spacing: normal;
        color: #333333;
        span {
          color: #e87167;
          font-weight: 800;
        }
      }
    }
    .field-title {
      color: #727d8c;
      font-size: 0.93rem;
    }
    .description {
      line-height: 1.43;
      color: #727d8c;
      font-size: 0.875rem;
      margin-top: 1.1rem;
    }
    input {
      box-sizing: border-box;
    }
    button[type=submit] {
      border-top-left-radius: 0px;
      border-top-right-radius: 0px;
      border-bottom-left-radius: 14px;
      border-bottom-right-radius: 14px;
      background-color: #d7e1ea;
      color: #727d8c;
      font-size: 1.125rem;
      font-weight: 600;
      margin-top: 15px;
      letter-spacing: -0.66px;
      width: 100%;
      height: 3.75rem !important;
      &.active {
        color: #ffffff;
        box-shadow: 0 8px 16px 0 rgba(51, 51, 51, 0.12);
        background-color: #e87167 !important;
      }
    }
  }
</style>
